import React from 'react';
import { useParams } from 'react-router-dom';
import HLPageTable from "../../shared/components/table/HLPageTable";
import type { ColDef } from "ag-grid-community";
import {
    AgreementStudentChangeReason,
    AgreementStudentChangeReasonNameMap,
    AgreementStudentHistoryView
} from "../../shared/types/agreement";
import { getAllAgreementStudentHistoriesFetch } from "../../app/axios/agreementFetches";
import { PageRequest } from "../../shared/types/page";
import { formatDateTimeForString } from "../../shared/utils/dateUtils";

const formatBalance = (value: number | null | undefined): string =>
    value === null || value === undefined ? '—' : String(value);

const columnDefs: ColDef<AgreementStudentHistoryView>[] = [
    {
        field: 'availableLessonsChange',
        headerName: 'Изменение уроков'
    },
    {
        field: 'availableLessonsBefore',
        headerName: 'Баланс до',
        valueFormatter: (params) => formatBalance(params.value)
    },
    {
        field: 'availableLessonsAfter',
        headerName: 'Баланс после',
        valueFormatter: (params) => formatBalance(params.value)
    },
    {
        field: 'changeReason',
        headerName: 'Причина',
        valueFormatter: (params) => AgreementStudentChangeReasonNameMap[params.value as AgreementStudentChangeReason] || params.value
    },
    {
        field: 'createdAt',
        headerName: 'Дата изменения',
        valueFormatter: (params) => formatDateTimeForString(params.value)
    },
    {
        field: 'userFullName',
        headerName: 'Учитель'
    }
];

const defaultColDef: ColDef<AgreementStudentHistoryView> = {
    sortable: false,
    filter: false,
    resizable: true,
    flex: 1,
    minWidth: 150
};

const AgreementStudentHistoryPage = () => {
    const {agreementId, studentId} = useParams<{ agreementId: string; studentId: string }>();

    const fetchData = async (pageRequest: PageRequest): Promise<any> => {
        const request = {
            ...pageRequest,
            sort: {orderBy: 'createdAt', orderType: 'desc' as const},
            filters: [
                ...(pageRequest.filters || []),
                {
                    fieldName: 'agreementId',
                    operator: '=',
                    fieldValue: agreementId
                },
                {
                    fieldName: 'studentId',
                    operator: '=',
                    fieldValue: studentId
                }
            ]
        };
        return getAllAgreementStudentHistoriesFetch(request);
    };

    return (
        <HLPageTable
            title="История изменений баланса"
            columns={columnDefs}
            defaultColDef={defaultColDef}
            filterConfig={[]}
            actionButtons={[]}
            fetchData={fetchData}
            height={window.innerHeight}
        />
    );
};

export default AgreementStudentHistoryPage;
